/* SectionNavigation - migrated to Tailwind */
export const sectionNavigationClassName = 'self-start';
